import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorDifficultyFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorDifficultyField: FC<CryptorDifficultyFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="difficulty"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Difficulté"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorDifficultyField;
